import {useDragDropManager} from "react-dnd";
import {useEffect, useRef, useState} from "react";

export const useVehicleDraggingMonitor = () => {
    const dragDropManager = useDragDropManager()
    const monitor = dragDropManager.getMonitor()
    const [isDragging, setIsDragging] = useState(false)
    const [didDrop, setDidDrop] = useState(false)
    const itemRef = useRef()
    useEffect(() => {
        const unsubscribe = monitor.subscribeToOffsetChange(() => {
            const dragging = monitor.isDragging()
            if (dragging !== isDragging) {
                setIsDragging(dragging)
            }
            // Only track the dragged item while a drag is actually in progress - if the backend's
            // drag-end event is ever missed (e.g. its source element unmounts mid-gesture), this keeps
            // a stale item from staying hidden indefinitely (isDisplayNone in AssignVehicleList).
            itemRef.current = dragging ? monitor.getItem() : null

            if (monitor.didDrop() !== didDrop) {
                setDidDrop(monitor.didDrop())
            }

        })
        return unsubscribe
    }, [monitor, setIsDragging, isDragging, didDrop, setDidDrop])

    return {isDragging: monitor.isDragging(),
            draggingItem: itemRef.current,
            didDrop: monitor.didDrop(),
    }
}